// extracted by mini-css-extract-plugin
module.exports = {"selection":"menu-incentive_selection__Bnsbr","groupPadding":"menu-incentive_groupPadding__GLDYu"};